<template>
  <span>{{ formattedPrice }}</span>
</template>

<script setup>
import { computed } from 'vue'
import { usePresentationMode } from '@/composables/usePresentationMode'

const props = defineProps({
  price: {
    type: Number,
    required: true,
  },
})
const { isPresentationModeEnabled } = usePresentationMode()

// Computed property that formats the price as currency
const formattedPrice = computed(() => {
  if (isPresentationModeEnabled.value) {
    return '#####'
  }

  return (props.price / 100).toFixed(2)
})
</script>
